import { Pipe, PipeTransform } from '@angular/core';

import { Utils } from 'app/utils/utils';

@Pipe({
  name: 'truncate',
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit = 20, separator = '…'): string {
    return Utils.truncate(value, limit, separator);
  }
}
